import { DownloadTextsListWordType } from 'components/shared/DownloadFile/DownloadTextWordType';
export const DownloadButton = ({ sortedTexts, user, setShowDownloadModel }) => {
  const hasDeliveredTexts = sortedTexts.some((text) => text.delivered);

  return hasDeliveredTexts ? (
    <span
      className="bt-download-circle"
      onClick={() =>
        DownloadTextsListWordType(
          sortedTexts.filter((text) => text.delivered),
          user,
          setShowDownloadModel
        )
      }
    />
  ) : (
    <span className="bt-download-circle  disabled" />
  );
};
